// "use client";
// import { useEffect, useMemo, useState } from "react";
// import { useSelector } from "react-redux";
// import { axiosGateway, axiosUsers } from "../../api/axios";
// import { MESSAGES_PATHS } from "../../api/endpoints";

// /**
//  * Hook pour le DOCTOR :
//  * renvoie la liste des PATIENTS qui ont écrit au docteur connecté.
//  */
// export function useMessageContactsForDoctor() {
//   const [contacts, setContacts] = useState([]);
//   const [loadingContacts, setLoadingContacts] = useState(false);
//   const [contactsError, setContactsError] = useState(null);

//   const currentDoctor = useSelector((state) => state.doctor?.user);
//   const currentDoctorId = String(
//     currentDoctor?.doctorId || currentDoctor?.pgId || currentDoctor?.id || ""
//   );

//   useEffect(() => {
//     const fetchContacts = async () => {
//       setLoadingContacts(true);
//       setContactsError(null);

//       try {
//         const url = MESSAGES_PATHS.CONTACTS_ME;

//         // 1️⃣ Récupérer les contacts bruts
//         const res = await axiosGateway.get(url, {
//           withCredentials: true,
//         });

//         const rawContacts = (Array.isArray(res.data)
//           ? res.data
//           : res.data?.data || []
//         ).filter((c) => {
//           // Skip self-referencing contacts (e.g. stray messages where
//           // fromUserId === toUserId === this doctor); the "patient" id
//           // there is actually the doctor's own id, which 404s against
//           // the patients endpoint and pollutes the contact list.
//           const pid = String(c.patientId || c.userId || c.peerId || "");
//           return !currentDoctorId || pid !== currentDoctorId;
//         });


//         if (!rawContacts.length) {
//           setContacts([]);
//           setLoadingContacts(false);
//           return;
//         }

//         // 2️⃣ Dédupliquer par patientId/userId/peerId
//         const mapByPatient = new Map();

//         const getKey = (c) => {
//           const pid = c.patientId || c.userId || c.peerId || null;
//           return pid ? String(pid) : null;
//         };

//         const getDateTs = (c) =>
//           new Date(c.lastDate || c.updatedAt || c.createdAt || 0).getTime();

//         for (const c of rawContacts) {
//           const key = getKey(c);
//           if (!key) {
//             console.warn(
//               "[useMessageContactsForDoctor] contact without patientId/userId/peerId:",
//               c
//             );
//             continue;
//           }

//           const existing = mapByPatient.get(key);
//           if (!existing) {
//             mapByPatient.set(key, c);
//           } else {
//             // on garde celui qui a la date la plus récente
//             if (getDateTs(c) > getDateTs(existing)) {
//               mapByPatient.set(key, c);
//             }
//           }
//         }

//         const uniqueContacts = Array.from(mapByPatient.values());

//         // 3️⃣ Enrichir chaque contact unique avec les infos patient
//         const enrichedContacts = await Promise.all(
//           uniqueContacts.map(async (contact) => {
//             const patientId =
//               contact.patientId || contact.userId || contact.peerId || null;

//             if (!patientId) {
//               return {
//                 id: "unknown",
//                 peerId: "unknown",
//                 userId: "unknown",
//                 fullName: "Unknown Patient",
//                 email: "",
//                 avatar: null,
//                 lastMessage: contact.lastMessage || "",
//                 lastDate:
//                   contact.lastDate || contact.updatedAt || contact.createdAt,
//                 lastType: contact.lastType || contact.messageType || "text",
//                 type: "patient",
//               };
//             }

//             try {

//               // ✅ CORRECTION : Template literal correct
//               const patientRes = await axiosUsers.get(`/${patientId}`, {
//                 withCredentials: true,
//               });

//               const patient = patientRes.data?.data || patientRes.data || {};

//               return {
//                 id: String(patientId),
//                 peerId: String(patientId),
//                 userId: String(patientId),
//                 fullName: patient.fullName || patient.name || "Patient",
//                 email: patient.email || "",
//                 avatar:
//                   patient.avatarUrl || patient.avatar || patient.photo || null,
//                 lastMessage: contact.lastMessage || "",
//                 lastDate:
//                   contact.lastDate || contact.updatedAt || contact.createdAt,
//                 lastType: contact.lastType || contact.messageType || "text",
//                 type: "patient",
//               };
//             } catch (err) {
//               console.error(
//                 `[useMessageContactsForDoctor] Error fetching patient ${patientId}:`,
//                 err
//               );

//               return {
//                 id: String(patientId) || "unknown",
//                 peerId: String(patientId) || "unknown",
//                 userId: String(patientId) || "unknown",
//                 fullName: "Unknown Patient",
//                 email: "",
//                 avatar: null,
//                 lastMessage: contact.lastMessage || "",
//                 lastDate:
//                   contact.lastDate || contact.updatedAt || contact.createdAt,
//                 lastType: contact.lastType || contact.messageType || "text",
//                 type: "patient",
//               };
//             }
//           })
//         );

//         // (optionnel) re-dédoublage côté front au cas où
//         const dedupEnrichedMap = new Map();
//         for (const c of enrichedContacts) {
//           const key = c.peerId || c.id;
//           const existing = dedupEnrichedMap.get(key);

//           if (!existing) {
//             dedupEnrichedMap.set(key, c);
//           } else {
//             const dNew = new Date(c.lastDate || 0).getTime();
//             const dOld = new Date(existing.lastDate || 0).getTime();
//             if (dNew > dOld) dedupEnrichedMap.set(key, c);
//           }
//         }

//         const finalContacts = Array.from(dedupEnrichedMap.values());

//         setContacts(finalContacts);
//       } catch (err) {
//         console.error("[useMessageContactsForDoctor] Error:", err);

//         if (err?.response?.status === 404 || err?.status === 404) {
//           setContacts([]);
//         } else {
//           setContactsError(
//             err?.message || "Erreur lors du chargement des contacts"
//           );
//         }
//       } finally {
//         setLoadingContacts(false);
//       }
//     };

//     fetchContacts();
//   }, [currentDoctorId]);

//   const sortedContacts = useMemo(() => {
//     return [...contacts].sort(
//       (a, b) =>
//         new Date(b.lastDate || 0).getTime() -
//         new Date(a.lastDate || 0).getTime()
//     );
//   }, [contacts]);

//   return {
//     contacts: sortedContacts,
//     loadingContacts,
//     contactsError,
//   };
// }

// export default useMessageContactsForDoctor;

"use client";

import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { axiosGateway } from "../../api/axios";
import { MESSAGES_PATHS } from "../../api/endpoints";

/**

* Hook pour le DOCTOR :
* renvoie la liste des PATIENTS qui ont écrit au docteur connecté.
*
* IMPORTANT :
* * CONTACTS_ME est la source des contacts de messaging.
* * patientId est l'identité utilisée pour la conversation.
* * On ne fait PAS de GET /api/users/:patientId.
* * Les informations déjà présentes dans CONTACTS_ME sont utilisées
* directement.
  */
  export function useMessageContactsForDoctor() {
  const [contacts, setContacts] = useState([]);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const [contactsError, setContactsError] = useState(null);

const currentDoctor = useSelector((state) => state.doctor?.user);

const currentDoctorId = String(
currentDoctor?.doctorId ||
currentDoctor?.pgId ||
currentDoctor?.id ||
""
).trim();

useEffect(() => {
let cancelled = false;

const fetchContacts = async () => {
  setLoadingContacts(true);
  setContactsError(null);

  try {
    const url = MESSAGES_PATHS.CONTACTS_ME;

    // ============================================================
    // 1. Récupérer les contacts depuis le messaging backend
    // ============================================================
    const res = await axiosGateway.get(url, {
      withCredentials: true,
    });

    if (cancelled) return;

    const rawData = Array.isArray(res.data)
      ? res.data
      : res.data?.data || [];

    const rawContacts = Array.isArray(rawData)
      ? rawData.filter((contact) => {
          const patientId = String(
            contact?.patientId ||
              contact?.userId ||
              contact?.peerId ||
              contact?.fromUserId ||
              ""
          ).trim();

          /*
           * Ne jamais considérer le médecin lui-même comme
           * un patient.
           */
          if (
            currentDoctorId &&
            patientId &&
            patientId === currentDoctorId
          ) {
            return false;
          }

          return Boolean(patientId);
        })
      : [];

    if (!rawContacts.length) {
      setContacts([]);
      return;
    }

    // ============================================================
    // 2. Dédupliquer par patientId
    // ============================================================
    const mapByPatient = new Map();

    const getPatientId = (contact) => {
      const value =
        contact?.patientId ??
        contact?.userId ??
        contact?.peerId ??
        contact?.fromUserId ??
        null;

      if (value == null) return null;

      const normalized = String(value).trim();

      return normalized || null;
    };

    const getDateTs = (contact) => {
      const value =
        contact?.lastDate ??
        contact?.lastMessageAt ??
        contact?.updatedAt ??
        contact?.createdAt ??
        0;

      const timestamp = new Date(value).getTime();

      return Number.isNaN(timestamp) ? 0 : timestamp;
    };

    for (const contact of rawContacts) {
      const patientId = getPatientId(contact);

      if (!patientId) {
        console.warn(
          "[useMessageContactsForDoctor] Contact without patientId:",
          contact
        );
        continue;
      }

      const existing = mapByPatient.get(patientId);

      if (!existing) {
        mapByPatient.set(patientId, contact);
        continue;
      }

      /*
       * On conserve le contact correspondant au dernier
       * message / dernière activité.
       */
      if (getDateTs(contact) > getDateTs(existing)) {
        mapByPatient.set(patientId, contact);
      }
    }

    const uniqueContacts = Array.from(mapByPatient.values());

    // ============================================================
    // 3. Construire les contacts sans GET /api/users/:id
    // ============================================================
    const enrichedContacts = uniqueContacts.map((contact) => {
      const patientId = getPatientId(contact);

      if (!patientId) {
        return {
          id: "unknown",
          peerId: "unknown",
          userId: "unknown",
          patientId: null,

          fullName: "Unknown Patient",
          name: "Unknown Patient",

          firstName: "",
          lastName: "",

          email: "",
          phone: "",
          avatar: null,

          lastMessage: contact?.lastMessage || "",
          lastDate:
            contact?.lastDate ||
            contact?.lastMessageAt ||
            contact?.updatedAt ||
            contact?.createdAt ||
            null,

          lastType:
            contact?.lastType ||
            contact?.messageType ||
            "text",

          type: "patient",
          role: "patient",

          subprofileId:
            contact?.subprofileId ??
            contact?.meta?.subprofileId ??
            null,

          effectiveProfileId:
            contact?.effectiveProfileId ??
            contact?.meta?.effectiveProfileId ??
            null,

          rawContact: contact,
        };
      }

      // ----------------------------------------------------------
      // Nom
      // ----------------------------------------------------------
      const firstName =
        contact?.firstName ||
        contact?.patientFirstName ||
        contact?.userFirstName ||
        "";

      const lastName =
        contact?.lastName ||
        contact?.patientLastName ||
        contact?.userLastName ||
        "";

      const computedName = `${firstName} ${lastName}`.trim();

      const fullName =
        contact?.fullName ||
        contact?.patientName ||
        contact?.userName ||
        contact?.name ||
        computedName ||
        "Patient";

      // ----------------------------------------------------------
      // Avatar
      // ----------------------------------------------------------
      const avatar =
        contact?.avatarUrl ||
        contact?.avatar ||
        contact?.photo ||
        contact?.patientAvatar ||
        contact?.userAvatar ||
        null;

      // ----------------------------------------------------------
      // Email
      // ----------------------------------------------------------
      const email =
        contact?.email ||
        contact?.patientEmail ||
        contact?.userEmail ||
        "";

      // ----------------------------------------------------------
      // Phone
      // ----------------------------------------------------------
      const phone =
        contact?.phone ||
        contact?.phoneNumber ||
        contact?.patientPhone ||
        "";

      // ----------------------------------------------------------
      // Last message
      // ----------------------------------------------------------
      const lastMessage =
        contact?.lastMessage ||
        contact?.message ||
        contact?.content ||
        "";

      // ----------------------------------------------------------
      // Last date
      // ----------------------------------------------------------
      const lastDate =
        contact?.lastDate ||
        contact?.lastMessageAt ||
        contact?.updatedAt ||
        contact?.createdAt ||
        null;

      // ----------------------------------------------------------
      // Message type
      // ----------------------------------------------------------
      const lastType =
        contact?.lastType ||
        contact?.messageType ||
        "text";

      return {
        /*
         * IMPORTANT :
         * patientId reste l'identité principale du contact.
         */
        id: String(patientId),
        peerId: String(patientId),
        userId: String(patientId),
        patientId: String(patientId),

        fullName,
        name: fullName,

        firstName,
        lastName,

        email,
        phone,
        avatar,

        lastMessage,
        lastDate,
        lastType,

        type: "patient",
        role: "patient",

        /*
         * Conserver les informations de sous-profil si elles
         * existent dans la réponse du backend.
         */
        subprofileId:
          contact?.subprofileId ??
          contact?.meta?.subprofileId ??
          null,

        effectiveProfileId:
          contact?.effectiveProfileId ??
          contact?.meta?.effectiveProfileId ??
          null,

        rawContact: contact,
      };
    });

    // ============================================================
    // 4. Dernière déduplication
    // ============================================================
    const dedupEnrichedMap = new Map();

    for (const contact of enrichedContacts) {
      const key = String(
        contact?.patientId ||
          contact?.peerId ||
          contact?.id ||
          ""
      ).trim();

      if (!key) continue;

      const existing = dedupEnrichedMap.get(key);

      if (!existing) {
        dedupEnrichedMap.set(key, contact);
        continue;
      }

      const newDate = new Date(
        contact?.lastDate || 0
      ).getTime();

      const oldDate = new Date(
        existing?.lastDate || 0
      ).getTime();

      const normalizedNewDate = Number.isNaN(newDate)
        ? 0
        : newDate;

      const normalizedOldDate = Number.isNaN(oldDate)
        ? 0
        : oldDate;

      if (normalizedNewDate > normalizedOldDate) {
        dedupEnrichedMap.set(key, contact);
      }
    }

    if (cancelled) return;

    const finalContacts = Array.from(
      dedupEnrichedMap.values()
    );

    setContacts(finalContacts);
  } catch (err) {
    if (cancelled) return;

    console.error(
      "[useMessageContactsForDoctor] Error:",
      err
    );

    /*
     * Un 404 sur CONTACTS_ME signifie qu'aucun contact
     * n'est disponible.
     *
     * IMPORTANT :
     * On ne fait aucun logout et on ne change pas de session.
     */
    if (
      err?.response?.status === 404 ||
      err?.status === 404
    ) {
      setContacts([]);
      return;
    }

    setContactsError(
      err?.response?.data?.message ||
        err?.message ||
        "Erreur lors du chargement des contacts"
    );

    setContacts([]);
  } finally {
    if (!cancelled) {
      setLoadingContacts(false);
    }
  }
};

fetchContacts();

return () => {
  cancelled = true;
};


}, [currentDoctorId]);

// ================================================================
// Trier par dernière activité
// ================================================================
const sortedContacts = useMemo(() => {
return [...contacts].sort((a, b) => {
const dateA = new Date(
a?.lastDate || 0
).getTime();


  const dateB = new Date(
    b?.lastDate || 0
  ).getTime();

  const normalizedA = Number.isNaN(dateA)
    ? 0
    : dateA;

  const normalizedB = Number.isNaN(dateB)
    ? 0
    : dateB;

  return normalizedB - normalizedA;
});


}, [contacts]);

return {
contacts: sortedContacts,
loadingContacts,
contactsError,
};
}

export default useMessageContactsForDoctor;
